import { StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'
import { colorList } from 'utils/colors'

export const themedButtonBarStyle = StyleSheet.create({
	view: {
		overflow: 'visible',
		flexDirection: 'row',
		justifyContent: 'center',
		backgroundColor: 'transparent'
	},
	
	buttonGroup: {
		overflow: 'visible',
		gap: 0,
		backgroundColor: colorList.WHITE.primary,
		borderRadius: ThemedValues.borderRadius,
		borderColor: colorList.PRIMARY.light,
		borderWidth: 1,
	},
	
	button: {
		justifyContent: 'center',
		width: 'auto',
		minWidth: 100,
		backgroundColor: 'transparent',
	},
	buttonText: {
		textAlign: 'center',
		color: colorList.PRIMARY.primary,
	},
	buttonTextActive: {
		textAlign: 'center',
		color: colorList.WHITE.primary,
	},
	
	badge: {
		alignSelf: 'center',
		top: -15,
		right: -5
	}
})
